import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";

import { APIStatus } from "./APIStatus";

const initialState = {
  isLoading: "loading",
  devices: null,
  newLocation: null,
  newLocationError: null,
  editedLocation: null,
  editedLocationError: null,
  feedList: null,
  deviceDatas: null,
  feedData: null,
  pastData: null,
  pastDataError: null,
  previousDeviceData: null,
  previousDeviceDataError: null,
  previousStreamData: null,
  previousStreamDataError: null,
  locations: null,
  deviceLocations: null,
  allLocations: null,
  allLocationsError: null,
  bbLocations: null,
  bbLocationsError: null,
  newWorkSiteLocations: null,
  newWorkSiteLocationsError: null,
  editedWorkSiteLocations: null,
  editedWorkSiteLocationsError: null,
  deleteSiteLocationStatus: APIStatus.idle,
  deleteSiteLocationReceipt: null,
  deleteSiteLocationError: null,
  categoryBBError: null,
  categoryBB: {
    pipelineSetbackDtss: null,
    pipelineSetbackTrunkSewers: null,
    pipelineSetbackWaterPipes: null,
    pipelineDtss: null,
    pipelineTrunkSewers: null,
    pipelineWaterPipes: null,
    pipelineSetbackRawWaterPipes: null,
    pipelineOutfallMh: null,
    loading: null,
  },
};

export const addWorkSiteLocations = createAsyncThunk(
  "addWorkSiteLocations",
  async (payload) => {
    let selectedOrg = payload.selectedOrg;
    let inputData = payload.inputData;
    const response = await axios.post(`${selectedOrg}/assets`, inputData);
    return response;
  }
);

export const editWorkSiteLocations = createAsyncThunk(
  "editWorkSiteLocations",

  async (payload) => {
    let selectedOrg = payload.selectedOrg;
    let inputData = payload.inputData;
    let assetKey = payload.assetKey;
    const response = await axios.patch(
      `${selectedOrg}/asset/${assetKey}`,
      inputData
    );
    return response;
  }
);

export const getAllLocations = createAsyncThunk(
  "getAllLocations",
  async (payload) => {
    const response = await axios.get(payload.url);
    return response;
  }
);

export const getBBLocations = createAsyncThunk(
  "getBBLocations",
  async (payload) => {
    const response = await axios.get(payload.url);

    return response;
  }
);

export const getCategoryLayerBB = createAsyncThunk(
  "getCategoryLayerBB",
  async (payload) => {
    let response = await axios.get(payload.url);
    response.fromPage = payload.fromPage;
    return response;
  }
);

export const getSiteDevices = createAsyncThunk(
  "getSiteDevices",
  async (payload) => {
    let orgdevicesObj = {};
    let organization = payload.organization;
    let isEnterpriseUser = payload.isEnterpriseUser;
    const response = axios.get(`/${organization}/devices`).then((res) => {
      let orgdevicesArr = [];
      if (res.data && res.data.results.length > 0) {
        if (isEnterpriseUser === "true") {
          orgdevicesArr = res.data.results;
        } else {
          orgdevicesArr = res.data.results.filter(
            (r) => r.organization_key === organization
          );
        }
      }
      orgdevicesObj = { results: orgdevicesArr };
      return orgdevicesObj;
    });
    return response;
  }
);

export const addSiteLocation = createAsyncThunk(
  "addSiteLocation",
  async (payload) => {
    let selectedOrg = payload.selectedOrg;
    let inputData = payload.inputData;
    const response = axios
      .post(`${selectedOrg}/locations`, inputData)
      .then((res) => {
        return res.data;
      });
    return response;
  }
);

export const editSiteLocation = createAsyncThunk(
  "editSiteLocation",
  async (payload) => {
    let locationKey = payload.locationKey;
    let inputData = payload.inputData;
    let selectedOrg = payload.selectedOrg;

    const response = axios
      .patch(`${selectedOrg}/locations/${locationKey}`, inputData)
      .then((res) => {
        return res.data;
      });
    return response;
  }
);

export const deleteSiteLocation = createAsyncThunk(
  "deleteSiteLocation",
  async (payload) => {
    const response = await axios.delete(payload.url);
    return response;
  }
);

export const getSiteDeviceFeeds = createAsyncThunk(
  "getSiteDeviceFeeds",
  async (payload) => {
    let deviceId = payload.deviceId;
    const response = axios
      .get(
        `/${localStorage.getItem(
          "organization"
        )}/feeds?device__device_id=${deviceId}`
      )
      .then((res) => {
        return res.data;
      });
    return response;
  }
);

export const getSiteDeviceData = createAsyncThunk(
  "getSiteDeviceData",
  async (payload) => {
    let deviceId = payload.deviceId;
    let selectedDate = payload.selectedDate;
    let deviceOrg = payload.deviceOrg;

    var startDate = moment(selectedDate).format("YYYY-MM-DD");
    var endDate = moment(selectedDate).format("YYYY-MM-DD");
    var startTime = startDate + " 00:00";
    var endTime = endDate + " 23:59";

    var utcstartDate = moment(startTime).utc().format("YYYY-MM-DD HH:mm:ss");
    var utcendDate = moment(endTime).utc().format("YYYY-MM-DD HH:mm:ss");
    const response = axios
      .get(
        `/${deviceOrg}/devices/${deviceId}/device-data?completed_at__range=${utcstartDate}, ${utcendDate}`
      )
      .then((res) => {
        return res.data;
      });

    return response;
  }
);

export const getSiteFeedData = createAsyncThunk(
  "getSiteFeedData",
  async (payload) => {
    let deviceId = payload.deviceID;
    let deviceOrg = payload.deviceOrg;

    var startDate = moment().format("YYYY-MM-DD");
    var endDate = moment().format("YYYY-MM-DD");
    var startTime = startDate + " 00:00";
    var endTime = endDate + " 23:59";
    let mapData = [];
    var utcstartDate = moment(startTime).utc().format("YYYY-MM-DD HH:mm:ss");
    var utcendDate = moment(endTime).utc().format("YYYY-MM-DD HH:mm:ss");

    let offsetVal = 0;
    let response = axios
      .get(
        `/${deviceOrg}/devices/${deviceId}/stream-data-full?completed_at__range=${utcstartDate},${utcendDate}&limit=3000&offset=${offsetVal}`,
        { headers: { accept: "application/json" } }
      )
      .then((res) => {
        let totalCount = res.data.count;
        let noofLoops = totalCount / 3000;
        let streamdatareq = [];
        let streamdatares = [];
        streamdatares.push(res.data.results);
        if (noofLoops > 1) {
          let loopInt = Number(noofLoops.toFixed(0));
          let forloops = loopInt;

          for (let j = 0; j < forloops; j++) {
            offsetVal = offsetVal + 3000;
            streamdatareq.push(
              axios.get(
                `/${deviceOrg}/devices/${deviceId}/stream-data-full?completed_at__range=${utcstartDate},${utcendDate}&limit=3000&offset=${offsetVal}`
              )
            );
          }
          axios.all(streamdatareq).then(
            axios.spread((...streamResp) => {
              // streamResp.map((s) => {
              streamResp.forEach((s) => {
                streamdatares.push(s.data.results);
              });

              if (streamdatares.length > 1) {
                var allDataArr = [].concat.apply([], streamdatares);
                mapData = allDataArr;
                return mapData;
              }
            })
          );
        } else {
          mapData = res.data.results;
          return mapData;
        }
      });
    return response;
  }
);

export const getPreviousSiteData = createAsyncThunk(
  "getPreviousSiteData",
  async (payload) => {
    let deviceUUID = payload.deviceUUID;
    let device_id = payload.device_id;
    let selectedDate = payload.selectedDate;

    let deviceOrg = payload.deviceOrg;

    return axios
      .get(
        `/${deviceOrg}/location-processed-data?file_created_at=${selectedDate}&device__device_id=${device_id}`
      )
      .then((res) => {
        let tData = res.data.results.filter((t) => {
          if (
            t.file_type === "stream_data" ||
            t.file_type === "device_data" ||
            t.file_type === "device_summary" ||
            t.file_type === "device_session_summary"
          ) {
            if (t.device) {
              if (t.device === deviceUUID) return true;
            } else {
              if (t.file_name.split("_")[0] === device_id) return true;
            }
          }
          return false;
        });
        return tData;
      });
  }
);

export const getPreviousSiteDeviceData = createAsyncThunk(
  "getPreviousSiteDeviceData",
  async (payload) => {
    let itemId = payload.itemId;

    const response = axios
      .get(
        `/${localStorage.getItem(
          "organization"
        )}/location-processed-data/${itemId}`
      )
      .then((res) => {
        return res.data;
      });
    return response;
  }
);

export const getPreviousSiteStreamData = createAsyncThunk(
  "getPreviousSiteStreamData",
  async (payload) => {
    let itemId = payload.itemId;
    let selectedOrg = payload.selectedOrg;

    const response = axios
      .get(`/${selectedOrg}/location-processed-data/${itemId}`)
      .then((res) => {
        return res.data;
      });
    return response;
  }
);

export const getWorkSiteLocations = createAsyncThunk(
  "getWorkSiteLocations",
  async (payload) => {
    let offset = payload.offset;
    let search = payload.search;
    let selectedOrg = payload.selectedOrg;

    let offsetValue = offset * 15;
    let apiEndPoint = "";

    if (search == null) {
      // apiEndPoint = `/${selectedOrg}/assets?asset_type=work_site`;
      // apiEndPoint = `/${selectedOrg}/locations?limit=15&offset=${offsetValue}`;

      apiEndPoint = `/${selectedOrg}/assets?asset_type=work_site&limit=15&offset=${offsetValue}`;
    } else {
      // apiEndPoint = `/${selectedOrg}/assets?asset_type=work_site`;

      // apiEndPoint = `/${selectedOrg}/locations?key=${search}`;
      apiEndPoint = `/${selectedOrg}/assets?asset_type=work_site&search=${search}&limit=15&offset=${offsetValue}`;
    }

    const response = axios.get(apiEndPoint).then((res) => {
      let temp = [];
      const applyToArray = (func, array) => func.apply(Math, array);
      res.data.results.forEach((value) => {
        let tempVal = {};
        let cornersLongLat;
        if (value.gps_shape?.coordinates.length > 0) {
          let pointsLong = [];
          let pointsLat = [];
          let coord = value.gps_shape?.coordinates.toString();
          let coordTemp = coord.split(",");
          coordTemp.forEach((value, index) => {
            if (index % 2 === 0) {
              pointsLong.push(value);
            } else {
              pointsLat.push(value);
            }
          });
          cornersLongLat = [
            [
              applyToArray(Math.min, pointsLong),
              applyToArray(Math.min, pointsLat),
            ],
            [
              applyToArray(Math.max, pointsLong),
              applyToArray(Math.max, pointsLat),
            ],
          ];
        }
        tempVal.geometry = value.gps_shape;
        tempVal.id = value.id;
        tempVal.type = "Feature";
        tempVal.properties = {
          key: value.key,
          name: value.name,
          powsRefNo: value.core_attributes.pows_approval_ref_number,
          projRefNo: value.core_attributes.project_ref_number,
          projTitle: value.core_attributes.project_title,
          location_type: "pipeline-dtss",
          cornersLatLng: cornersLongLat,
        };
        temp.push(tempVal);
      });
      let locations = {
        length: res.data.count,
        data: temp,
      };
      return locations;
    });
    return response;
  }
);

export const getSiteDeviceLocations = createAsyncThunk(
  "getSiteDeviceLocations",
  async (payload) => {
    let search = payload.search;
    let selectedOrg = payload.selectedOrg;

    const response = axios
      .get(`/${selectedOrg}/locations?key=${search}`)
      .then((res) => {
        let locations = res.data.results.features.map((item, index) => {
          let coordinates = item.geometry.coordinates;

          if (item.bbox && item.bbox.length === 4) {
            item.properties.cornersLatLng = [
              [item.bbox[0], item.bbox[1]],
              [item.bbox[2], item.bbox[3]],
            ];
          }
          return {
            ...item,
            type: "Feature",
            // properties: item,
            geometry: {
              type: item.geometry.type, //'Polygon',
              coordinates: coordinates,
            },
          };
        });

        return locations;
      });

    return response;
  }
);

const siteManagementSlice = createSlice({
  name: "sites",
  initialState,
  reducers: {
    reset(state, action) {
      state.devices = null;
      state.devicesMetas = null;
    },
    resetAckData(state, action) {
      state.acknowledgeReceipt = null;
      state.acknowledgeError = null;
    },
    clearDeviceLocations(state, action) {
      state.deviceLocations = null;
    },
    clearDetailData(state, action) {
      state.feedData = null;
      state.pastData = null;
      state.previousStreamData = null;
      state.previousDeviceData = null;
      state.deviceLocations = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSiteDevices.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getSiteDevices.fulfilled, (state, action) => {
        state.devices = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getSiteDevices.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
      })

      .addCase(addSiteLocation.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(addSiteLocation.fulfilled, (state, action) => {
        state.newLocation = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(addSiteLocation.rejected, (state, action) => {
        state.newLocationError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(editSiteLocation.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(editSiteLocation.fulfilled, (state, action) => {
        state.editedLocation = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(editSiteLocation.rejected, (state, action) => {
        state.editedLocationError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getSiteDeviceFeeds.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getSiteDeviceFeeds.fulfilled, (state, action) => {
        state.feedList = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getSiteDeviceFeeds.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
      })
      .addCase(getSiteDeviceData.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getSiteDeviceData.fulfilled, (state, action) => {
        state.deviceDatas = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getSiteDeviceData.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
      })
      .addCase(getSiteFeedData.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getSiteFeedData.fulfilled, (state, action) => {
        state.feedData = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getSiteFeedData.rejected, (state, action) => {
        state.feedDataError = action.data;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getPreviousSiteData.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getPreviousSiteData.fulfilled, (state, action) => {
        state.pastData = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getPreviousSiteData.rejected, (state, action) => {
        state.pastDataError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getPreviousSiteDeviceData.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getPreviousSiteDeviceData.fulfilled, (state, action) => {
        state.previousDeviceData = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getPreviousSiteDeviceData.rejected, (state, action) => {
        state.previousDeviceDataError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getPreviousSiteStreamData.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getPreviousSiteStreamData.fulfilled, (state, action) => {
        state.previousStreamData = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getPreviousSiteStreamData.rejected, (state, action) => {
        state.previousStreamDataError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getWorkSiteLocations.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getWorkSiteLocations.fulfilled, (state, action) => {
        state.workSiteLocations = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getWorkSiteLocations.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
      })
      .addCase(getSiteDeviceLocations.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(getSiteDeviceLocations.fulfilled, (state, action) => {
        state.deviceLocations = action.payload;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getSiteDeviceLocations.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
      })
      .addCase(getAllLocations.fulfilled, (state, action) => {
        state.allLocations = action.payload.data;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getAllLocations.rejected, (state, action) => {
        state.allLocationsError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getBBLocations.fulfilled, (state, action) => {
        state.bbLocations = action.payload.data;

        state.isLoading = APIStatus.loaded;
      })
      .addCase(getBBLocations.rejected, (state, action) => {
        state.bbLocationsError = action.payload;
        state.isLoading = APIStatus.failed;
      })
      .addCase(getCategoryLayerBB.pending, (state, action) => {
        if (action.meta.arg.fromPage === "dashboard") {
          state.categoryBB.loading = APIStatus.loading;
        }
      })
      .addCase(getCategoryLayerBB.fulfilled, (state, action) => {
        let value = action.payload.config.url;
        if (value !== null) {
          let trimdat = value.split("&location_type=");

          let categoryName = trimdat.pop();

          switch (categoryName) {
            case "pipeline-setback-dtss":
              state.categoryBB.pipelineSetbackDtss = action.payload.data;
              break;

            case "pipeline-setback-trunk-sewers":
              state.categoryBB.pipelineSetbackTrunkSewers = action.payload.data;
              break;

            case "pipeline-setback-water-pipes":
              state.categoryBB.pipelineSetbackWaterPipes = action.payload.data;
              break;

            case "pipeline-dtss":
              state.categoryBB.pipelineDtss = action.payload.data;
              break;

            case "pipeline-outfall-pipes":
              state.categoryBB.pipelineOutfallMh = action.payload.data;
              break;

            case "pipeline-trunk-sewers":
              state.categoryBB.pipelineTrunkSewers = action.payload.data;
              break;

            case "pipeline-water-pipes":
              state.categoryBB.pipelineWaterPipes = action.payload.data;
              break;

            case "pipeline-setback-raw-water-pipes":
              state.categoryBB.pipelineSetbackRawWaterPipes =
                action.payload.data;
              break;

            default:
              console.log("Invalid selection->", categoryName);
          }
          if (action.payload.fromPage === "dashboard") {
            state.categoryBB.loading = APIStatus.loaded;
          }
        }
        state.isLoading = APIStatus.loaded;
      })
      .addCase(getCategoryLayerBB.rejected, (state, action) => {
        state.categoryBBError = action.payload;
        state.categoryBB.loading = APIStatus.failed;

        state.isLoading = APIStatus.failed;
      })
      .addCase(addWorkSiteLocations.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(addWorkSiteLocations.fulfilled, (state, action) => {
        state.newWorkSiteLocations = action.payload.data;
        state.newWorkSiteLocationsError = null;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(addWorkSiteLocations.rejected, (state, action) => {
        state.isLoading = APIStatus.failed;
        state.newWorkSiteLocations = null;
        state.newWorkSiteLocationsError = action?.error;
      })
      .addCase(editWorkSiteLocations.pending, (state, action) => {
        state.isLoading = APIStatus.loading;
      })
      .addCase(editWorkSiteLocations.fulfilled, (state, action) => {
        state.editedWorkSiteLocations = action.payload.data;
        state.editedWorkSiteLocationsError = null;
        state.isLoading = APIStatus.loaded;
      })
      .addCase(editWorkSiteLocations.rejected, (state, action) => {
        state.editedWorkSiteLocationsError = action?.error;
        state.editedWorkSiteLocations = null;
        state.isLoading = APIStatus.failed;
      })
      .addCase(deleteSiteLocation.pending, (state, action) => {
        state.deleteSiteLocationStatus = APIStatus.loading;
      })
      .addCase(deleteSiteLocation.fulfilled, (state, action) => {
        state.deleteSiteLocationStatus = APIStatus.loaded;
        state.deleteSiteLocationReceipt = "Deleted Successfully";
        state.deleteSiteLocationError = null;
      })
      .addCase(deleteSiteLocation.rejected, (state, action) => {
        state.deleteSiteLocationStatus = APIStatus.failed;
        state.deleteSiteLocationError = action.error;
      });
  },
});

export const { load, resetAckData, clearDeviceLocations, clearDetailData } =
  siteManagementSlice.actions;

export default siteManagementSlice.reducer;
